// extracted by mini-css-extract-plugin
export default {"legalBox":"AcceptInvitationCard_legalBox__JoASf","inlineModalLink":"AcceptInvitationCard_inlineModalLink__VjZ+h"};